import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ReactDOM from "react-dom";
import RootContainer from "./root-container";
import AuthenticatorContainer from "./authenticator-container";
import ErrorBoundaryContainer from "./error-boundary-container";
import SignIn from "../components/auth/SignIn";
import Auth from "../components/auth/Auth";

if (process.env.NODE_ENV === "development") {
  if (window.STUDENT_ENV.ACCENTED === "true") {
    import("accented").then(({ accented }) => {
      accented();
    });
  } else {
    import("@axe-core/react").then((axe) => {
      axe(React, ReactDOM, 1000);
    });
  }
}

export default function AuthContainer() {
  return (
    <ErrorBoundaryContainer>
      <Router>
        <Routes>
          <Route path="/landing" element={<SignIn />} />
          <Route path="/auth" element={<Auth />} />
          <Route
            path="/*"
            element={
              <AuthenticatorContainer>
                <RootContainer />
              </AuthenticatorContainer>
            }
          />
        </Routes>
      </Router>
    </ErrorBoundaryContainer>
  );
}
